import { useEffect, useState } from 'react';

/** Seconds left on a cooldown, ticking down once a second; ``start(n)`` restarts it. */
export function useCountdown(): [number, (seconds: number) => void] {
  const [left, setLeft] = useState(0);

  useEffect(() => {
    if (left <= 0) return;
    const id = setTimeout(() => setLeft((s) => Math.max(0, s - 1)), 1_000);
    return () => clearTimeout(id);
  }, [left]);

  return [left, (seconds: number) => setLeft(Math.max(0, Math.ceil(seconds)))];
}
